import { CalendarToday } from "@mui/icons-material";

const CalendarTodayIcon = () => (
  <CalendarToday />
);

export default CalendarTodayIcon;